<template>
    <div class="gz-checkup">
         <gz-input-container
            type="filter"
            label="Дата проверки"
            class="gz-filter__item gz-checkup__date"
            :valid="date.valid"
            :validationMessage="date.validationMessage"  
            >
                <GZ-DateInput 
                    @dateValue="date.value = $event" 
                    :value="date.value"
                    class="gz-date-input_no-border gz-date-input_calend-up"
                />
        </gz-input-container>
        
        <gz-select-container 
            label="Статус проверки"
            type="filter"
            class="gz-filter__item gz-checkup__status-select"
            :dataList="checkupStatusList"
            @selectedItem="status.value = $event"   
            :required="true"
            :valid="status.valid"
            :validationMessage="status.validationMessage"
        >
            <GZ-TextInput
                :importedData="status.value.name"
                :readonly="true"
                :selectType="true"
            />
        </gz-select-container>
        
         <gz-input-container 
                label="Номер акта"
                class="gz-filter__item"    
            >
                <GZ-TextInput 
                    @value="actnumber.value = $event"
                    :importedData="actnumber.value"
                />
            </gz-input-container>

        <gz-input-container
            type="filter"
            label="Комментарии"
            class="gz-filter__item gz-checkup__note"  
        >
            <textarea v-model="notes"></textarea>
        </gz-input-container>

        <section class="gz-file-upload">
            <section class="gz-image-preview">
                <div 
                    v-for="(item, index) in previewImages"
                    :key="index"
                    class="gz-image-preview__item"
                    :style="'background-image: url('+ item +')'" 
                >
                    <span class="icon-cross1 gz-image-preview__close" @click="deleteFile(index, files, previewImages)"></span>
                </div>
            </section>
            <input 
                type="file" 
                multiple
                max="5"
                accept="image/jpeg, image/jpg, image/png, image/gif"
                @change="getFiles"
            />
        </section>

        <GZ-BaseButton
            v-if="data.objectType"
            value="добавить проверку"
            class="gz-button gz-button_default" 
            icon="icon-checkmark"
            :loading="loading"
            @click="data.objectType === 'bid' ? addCheckup('building') : addCheckup('property')"
        />
        <GZ-BaseButton
            v-else
            value="редактировать проверку"
            class="gz-button gz-button_default" 
            icon="icon-checkmark"
            :loading="loading"
            @click="data.attributes.pid  ? editCheckup('property') : editCheckup('building')"
        />
    </div>
</template>

<script>
export default {
    name: 'BaseCheckup',

    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            created: {
                value: new Date(),
                valid: true,
                validationMessage: ''
            },
            date: {
                value: '',
                valid: true,
                validationMessage: ''
            },
            status: {
                value: {},
                valid: true,
                validationMessage: ''
            },
            actnumber: {
                value: '',
                valid: true,
                validationMessage: ''
            },
            notes: '',
            files: [],
            previewImages: [],
            loading: false
        }
    },
    computed: {
        checkupStatusList() {
            return this.$store.getters['filterCheckupStatus']
        }
    },
    mounted() {
        if (!this.data.objectType) {
            //Определяем - редактирование или добавление
            //Если редактирование существующей проверки, значит не должно быть типа здание - нет 'bid'
            this.$store.dispatch('checkupsGetId', this.data.id)
                .then(() => {
                    const checkup = this.$store.getters['checkupById']

                    this.created.value = new Date(checkup.attributes.created)
                    this.date.value = new Date(checkup.attributes.date)
                    this.status.value = {
                        name: this.enumFilterMap('get', checkup.attributes.status, this.$store.getters['filterCheckupStatus']),
                        value: checkup.attributes.status
                    }
                    this.actnumber.value = checkup.attributes.actnumber
                    this.notes = checkup.attributes.notes
                })
        }

    },
    methods: {
        addCheckup(type) {
            //type - building или property
            this.$store.dispatch('fileUpload', this.files)
                .then((response) => {
                    let attributes = {}
                    
                    let pics = []
                    response.forEach(item => {
                        pics.push(item.data[0])
                    })
                    
                    if (type === 'building') {
                        attributes = {
                            uid: this.$store.getters['authUserId'],
                            bid: this.data.id,
                            created: this.created.value.toISOString().split('.')[0],
                            date: this.date.value.toISOString().split('.')[0],
                            status: this.status.value.value,
                            actnumber: this.actnumber.value,
                            notes: this.notes,
                            pics: pics,
                            verifiedByUid: ''
                        }
                    }
                    if (type === 'property') {
                        attributes = {
                            uid: this.$store.getters['authUserId'],
                            pid: this.data.id,
                            // bid: this.$store.getters['addressesShelter'].attributes.bid,
                            created: this.created.value.toISOString().split('.')[0],
                            date: this.date.value.toISOString().split('.')[0],
                            status: this.status.value.value,
                            actnumber: this.actnumber.value,
                            notes: this.notes,
                            pics: pics,
                            verifiedByUid: ''
                        }
                    }
                    
                    this.$axios({
                        method: 'post',
                        url: 'checkup',
                        data: {
                            data: {
                                type: 'checkup',
                                attributes: attributes
                            }
                        }
                    }, this.loading = true)
                    .then(response => {
                        this.loading = false
                        this.$store.dispatch('addressCheckupStatus')
                        this.$store.dispatch('modalClose')
                    })
                    .catch(err => {
                        this.loading = false
                        console.log('Ошибка добавления проверки: ', err.response)
                    })
                })            
        },
        editCheckup(type) {
            //type - building или property
            if (this.files.length > 0) {
                this.$store.dispatch('fileUpload', this.files)
                    .then((response) => {
                        let pics = []
                        response.forEach(item => {
                            pics.push(item.data[0])
                        })

                        let checkupData = this.data.attributes

                        checkupData.status = this.status.value.value
                        checkupData.created = this.created.value.toISOString().split('.')[0]
                        checkupData.date = this.date.value.toISOString().split('.')[0]
                        checkupData.actnumber = this.actnumber.value
                        checkupData.notes = this.notes
                        checkupData.pics = pics

                        let data = {}

                        if (type === 'building') {
                            data = {
                                type: 'checkup',
                                // id: this.data.id,
                                attributes: checkupData
                            }
                        }
                        if (type === 'property') {
                            data = {
                                type: 'checkup',
                                attributes: checkupData
                            }
                        }

                        this.$axios({
                            method: 'PATCH',
                            url: 'checkup/' + this.data.id,
                            data: {data}
                        }, this.loading = true)
                        .then(response => {
                            this.loading = false
                            this.$store.dispatch('addressCheckupStatus')
                            this.$store.dispatch('modalClose')
                        })
                        .catch(err => {
                            this.loading = false
                            console.log('Ошибка добавления проверки: ', err.response)
                        })
                    })
            } else {
                let checkupData = this.data.attributes
                checkupData.status = this.status.value.value
                checkupData.created = this.created.value.toISOString().split('.')[0]
                checkupData.date = this.date.value.toISOString().split('.')[0]
                checkupData.actnumber = this.actnumber.value
                checkupData.notes = this.notes

                let data = {}

                if (type === 'building') {
                    data = {
                        type: 'checkup',
                        // id: this.data.id,
                        attributes: checkupData
                    }
                }
                if (type === 'property') {
                    data = {
                        type: 'checkup',
                        attributes: checkupData
                    }
                }

                this.$axios({
                    method: 'PATCH',
                    url: 'checkup/' + this.data.id,
                    data: {data}
                }, this.loading = true)
                .then(response => {
                    this.loading = false
                    this.$store.dispatch('addressCheckupStatus')
                    this.$store.dispatch('modalClose')
                })
                .catch(err => {
                    this.loading = false
                    console.log('Ошибка добавления проверки: ', err.response)
                })
            }
        },
        getFiles() {
            let reader;
            
            Object.values(event.target.files).forEach((item, index) => {
                this.files.push(item)

                reader = new FileReader()
                reader.readAsDataURL(item)
                reader.onload = event => {
                    this.previewImages.push(event.target.result)
                }
            })            
        },
        deleteFile(index, files_arr, preview_arr) {
            files_arr.splice(index, 1)
            preview_arr.splice(index, 1)
        }
    }
}
</script>